import { render } from "./RenderedHTMLOverviewBox.vue?vue&type=template&id=52962000"
import script from "./RenderedHTMLOverviewBox.vue?vue&type=script&lang=js"
export * from "./RenderedHTMLOverviewBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__